import {
  Button,
  FormContextWrapper,
  Input,
  Layout,
  useFormValues,
} from '@pimbutton/tast-components-lib';
import resetPassword from 'actions/password/reset';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import AuthVisual from '../AuthVisual/AuthVisual';

export default function ResetPassword() {
  const [cantSend, setCantSend] = useState(true);
  const { formValues, handleChange, errors, setErrors } = useFormValues({
    email: '',
    password: '',
    password_confirmation: '',
  });

  const dispatch = useReduxAction();
  const { push } = useHistory();
  const { location } = useHistory();

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    dispatch(
      resetPassword({
        ...formValues,
        token: location?.search?.substring(1),
      })
    )
      .then(() => push('/'))
      .catch(({ response }: { response: any }) => {
        setErrors((prev: any) => ({ ...prev, ...response?.data?.errors }));
      });
  }

  useEffect(() => {
    if (
      formValues?.email &&
      formValues?.password_confirmation &&
      formValues?.password
    )
      return setCantSend(false);
    setCantSend(true);
  }, [formValues]);

  return (
    <Layout
      authVisual={<AuthVisual />}
      title="Wachtwoord resetten"
      inputs={
        <FormContextWrapper
          onChange={handleChange}
          errors={errors}
          formValues={formValues}
        >
          <Input placeholder="E-mailadres" name="email" label="Email" />
          <Input placeholder="Wachtwoord" name="password" label="Wachtwoord" />
          <Input
            placeholder="Herhaal wachtwoord"
            name="password_confirmation"
            label="Herhaal wachtwoord"
          />
        </FormContextWrapper>
      }
      buttons={
        <>
          <Button fullWidth inactive={cantSend}>
            Reset wachtwoord
          </Button>
          <Button fullWidth variant="white" onClick={() => push('/inloggen')}>
            Ik weet mijn wachtwoord alweer
          </Button>
        </>
      }
      handleSubmit={(e) => handleSubmit(e)}
    />
  );
}
